function convertKilogramsToGrams(num){
  let eq = 'Converting ' + num +" kilograms to grams: \n"+
    num +" * 1000 = ";
    let rep = num * 1000;
  return eq + rep.toFixed(2);
}

function convertKilogramsToOunces(num){
  let eq = 'Converting ' + num +" kilograms to ounces: \n"+
    num +" * 35.274 = ";
  let rep = num * 35.274;
  return eq + rep.toFixed(2);
}

function convertKilogramsToPounds(num){
  let eq = 'Converting ' + num +" kilograms to pounds: \n"+
    num +" * 2.2046 = ";
  let rep = num *  2.2046 ;
  return eq + rep.toFixed(2);
}

function convertKilogramsToStones(num){
  let eq = 'Converting ' + num +" kilograms to stones: \n"+
    num +" * 0.1574 = ";
  let rep = num * 0.1574;
  return eq + rep.toFixed(3);
}


export {
  convertKilogramsToStones, convertKilogramsToPounds, convertKilogramsToOunces,
  convertKilogramsToGrams};
